class ABTestVariantCacheClass {}

export const ABTestVariantCache = new ABTestVariantCacheClass();
